import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import baseReducer from '../features/base/slice';
import translationReducer from '../features/translation/slice';
import filterReducer from '../features/filter/filterSlice';
import pricingReducer from '../features/pricing/pricingSlice';
import authReducer from '../features/auth/slice';
import userReducer from '../features/user/slice';

export const store = configureStore({
  reducer: {
    base: baseReducer,
    translations: translationReducer,
    filters: filterReducer,
    user: userReducer,
    auth: authReducer,
    pricing: pricingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
